import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ExpansionFormComponent } from '@app/shared/abstracts/expansion-form.component';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { INTEGER_PATTERN, PERIOD, VALUE_NEVER } from '@app/company/routes/settings/components/utils';

export interface TaskReminderForm {
  overdueDays: number;
}
@Component({
  selector: 'tc-task-reminder',
  templateUrl: './task-reminder.component.html',
  styleUrls: ['./task-reminder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskReminderComponent extends ExpansionFormComponent<TaskReminderForm, TaskReminderForm>
  implements OnChanges {

  @Input()
  connection = false;

  @Input()
  errMsg = '';

  @Input()
  hasRemove = false

  @Output()
  readonly remove = new EventEmitter<void>();

  @Output()
  readonly closeDialog = new EventEmitter<void>();

  public neverForConfirmLine = false;
  public readonly periodList = PERIOD;

  public form = new UntypedFormGroup({
    overdueDays: new UntypedFormControl(1, [
      Validators.pattern(INTEGER_PATTERN),
      Validators.min(1),
      Validators.required,
    ]),
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.value.currentValue) {
      const countDays = changes.value.currentValue.overdueDays;
      if (countDays === VALUE_NEVER) {
        this.neverForConfirmLine = true;
        this.removeMinValidator();
      } else {
        this.addAllValidators();
      }
    }
  }

  toggle(value: boolean): void {
    if (value) {
      this.removeMinValidator();
      this.form.patchValue({
        overdueDays: VALUE_NEVER,
      });
    } else {
      this.addAllValidators();
    }
    this.neverForConfirmLine = value;
  }

  removeMinValidator(): void {
    const control = this.form.get('overdueDays')!;
    control.setValidators([Validators.pattern(INTEGER_PATTERN), Validators.required]);
    control.updateValueAndValidity();
  }

  addAllValidators(): void {
    const control = this.form.get('overdueDays')!;
    control.setValidators([Validators.pattern(INTEGER_PATTERN), Validators.min(1), Validators.required]);
    control.updateValueAndValidity();
  }

  public cancel(): void {
    super.cancel();
    this.neverForConfirmLine = this.entity!.overdueDays === VALUE_NEVER;
  }

  get normalizedFormValue(): TaskReminderForm {
    const value: TaskReminderForm = this.form.value

    const data: TaskReminderForm = {
      overdueDays: Number(value.overdueDays),
    };

    return data;
  }

  getDescription(): string {
    if (this.neverForConfirmLine) {
      return $localize`:@@company.settings.reminder.description.never:Email reminders for suppliers`;
    }

    return `${this.entity?.overdueDays} day(s) after the issue date`;
  }

  onRemove() {
    this.remove.emit();
  }

  onClose() {
    this.closeDialog.emit();
  }
}
